import {
  createContext,
  useState,
  useMemo,
  ReactNode,
  useContext,
  useEffect,
} from 'react';
import { getContent } from '../../api/content';
import { Packages } from '../../types/package';
import { ArticlesType } from '../../types/article';
import { useNavigate } from 'react-router-dom';

interface ContentContextInterface {
  content: ArticlesType | null;
  loadContent: (packageId: string) => void;
}

export const ContentContext = createContext<ContentContextInterface | null>(
  null,
);

function ContentContextProvider({
  children,
  value,
}: {
  children: ReactNode;
  value: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [key: string]: any;
  };
}) {
  const [content, setContent] = useState<ArticlesType | null>(null);
  const navigate = useNavigate();

  const loadContent = async (packageId: string) => {
    try {
      const response = await getContent(packageId);
      if (response.articles) setContent(response);
    } catch (err) {
      console.log(err);
      navigate('/error');
    }
  };

  const contextValue = useMemo(
    () => ({
      content,

      loadContent,
      ...value,
    }),
    [content, value],
  );

  return (
    <ContentContext.Provider value={contextValue}>
      {children}
    </ContentContext.Provider>
  );
}

ContentContextProvider.defaultProps = {
  value: {},
};

export default ContentContextProvider;

export const useGetContent = (contentId: string) => {
  const context = useContext(ContentContext);
  useEffect(() => {
    if (!context?.content || context?.content.id !== contentId) {
      context?.loadContent(contentId);
    }
  }, [contentId]);

  return context?.content;
};

export const useContent = () => {
  return useContext(ContentContext);
};
